"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const CodeFind = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 24,
  height: 24,
  viewBox: "-1 0 24 24"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M16.028 12a4.032 4.032 0 0 1 4.027 4.028c0 .82-.248 1.582-.67 2.218L22 20.862 20.861 22l-2.616-2.615a3.998 3.998 0 0 1-2.217.671A4.032 4.032 0 0 1 12 16.028 4.032 4.032 0 0 1 16.028 12zM13.924 2L18 5.96v4.067a6.382 6.382 0 0 0-1.778-.253c-3.478 0-6.222 2.673-6.222 6.045 0 2.202 1.216 4.124 3.028 5.181h-9.25C2.798 21 2 20.225 2 19.273V3.727C2 2.775 2.797 2 3.778 2h10.146zm2.104 11.611a2.42 2.42 0 0 0-2.417 2.417 2.42 2.42 0 0 0 2.417 2.417 2.42 2.42 0 0 0 2.416-2.417 2.42 2.42 0 0 0-2.416-2.417zm-8.434-2.719l-3.295 3.202 3.295 3.201 1.257-1.221-2.039-1.98 2.039-1.98-1.257-1.222zm5.073-8.028v4.318h4.444l-4.444-4.318z",
  fill: "none",
  fillRule: "evenodd"
}));
var _default = exports.default = CodeFind;